import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { Table, TableBody, TableHead, TableHeader, TableRow } from '@/components/ui/table';

const platformColors: Record<string, string> = {
  tiktok: 'bg-cyan-500/10 text-cyan-400 border-cyan-500/30',
  instagram: 'bg-pink-500/10 text-pink-400 border-pink-500/30',
  youtube: 'bg-red-500/10 text-red-400 border-red-500/30',
};

/** Shared submission presentation; campaign types retain their own cells/actions. */
export function CampaignSubmissionTable({ platform, count, columns, children }: {
  platform: string;
  count: number;
  columns: readonly { label: ReactNode; className?: string }[];
  children: ReactNode;
}) {
  const { t } = useTranslation();
  const color = platformColors[platform] || 'bg-primary/10 text-primary border-primary/30';
  return <div className="min-w-0">
    <div className="mb-2 flex items-center gap-2">
      <span className={`inline-flex items-center rounded-full border px-2.5 py-0.5 text-xs font-bold uppercase tracking-wider ${color}`}>{platform.toUpperCase()}</span>
      <span className="text-xs text-muted-foreground">{t('campaign.submissions.clipsCount', { count })}</span>
    </div>
    <div className="overflow-hidden rounded-md border">
      <div className="max-h-[420px] overflow-y-auto">
        <Table>
          <TableHeader className="sticky top-0 z-10 bg-background"><TableRow>{columns.map((column, index) => <TableHead key={index} className={column.className}>{column.label}</TableHead>)}</TableRow></TableHeader>
          <TableBody>{children}</TableBody>
        </Table>
      </div>
    </div>
  </div>;
}
